/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay[_ngcontent-%COMP%]{background:#fff;color:#666;position:fixed;height:100%;width:100%;z-index:5000;top:0;left:0;float:left;text-align:center;padding-top:25%;opacity:.8}"];
export { styles as styles };
